import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppNotification } from '../../services/api';
import { useNotifications } from '../../hooks/useNotifications';

const timeAgo = (iso: string) => {
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
};

interface Props {
  items: AppNotification[];
  onNavigate?: () => void;
}

const NotificationList: React.FC<Props> = ({ items, onNavigate }) => {
  const { markRead } = useNotifications();
  const navigate = useNavigate();

  if (items.length === 0) {
    return <p className="px-4 py-6 text-sm text-gray-500 text-center">No notifications yet.</p>;
  }

  const open = (n: AppNotification) => {
    if (!n.read) markRead(n.id);
    if (n.url) {
      navigate(n.url);
      onNavigate?.();
    }
  };

  return (
    <ul className="divide-y divide-gray-100">
      {items.map((n) => (
        <li key={n.id}>
          <button
            onClick={() => open(n)}
            className={`w-full text-left px-4 py-3 hover:bg-gray-50 flex gap-3 ${n.read ? '' : 'bg-blue-50'}`}
          >
            <span className={`mt-1.5 h-2 w-2 flex-shrink-0 rounded-full ${n.read ? 'bg-transparent' : 'bg-blue-600'}`} />
            <span className="min-w-0">
              <span className="block text-sm font-medium text-gray-900">{n.title}</span>
              <span className="block text-sm text-gray-600">{n.body}</span>
              <span className="block text-xs text-gray-400 mt-1">{timeAgo(n.created_at)}</span>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
};

export default NotificationList;
